import { render, staticRenderFns } from "./GoodsRequest.vue?vue&type=template&id=61d3ae9c&scoped=true"
import script from "./GoodsRequest.vue?vue&type=script&lang=js"
export * from "./GoodsRequest.vue?vue&type=script&lang=js"
import style0 from "./GoodsRequest.vue?vue&type=style&index=0&id=61d3ae9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3ae9c",
  null
  
)

export default component.exports